import { h } from 'preact';

export default ({ modifierClass = '' }) => ((
  <div className={`w-loading-pulse ${modifierClass}`}>
    <div />
  </div>
));



// WEBPACK FOOTER //
// ./components/LoadingPulse.js